<template>
  <div>
    <cItem
      v-for="(item) in treeList"
      :key="item.Id"
      :pitem="item"
      readonly
    ></cItem>
  </div>
</template>
<script>
import cItem from '@/modules/contract/pages/freightnew/cmodel/pmItem.vue'
import { getCModelDetail } from '@/modules/contract/api/freightnew.js'
export default {
  name: 'Step1',
  components: { cItem },
  props: {
    bform: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data () {
    return {
      treeList: [],
      issubmit: false
    }
  },
  computed: {},
  mounted () {
    this.loadPageData()
  },
  methods: {
    loadPageData () {
      if (this.bform) {
        getCModelDetail({ RecordId: this.bform.Id }).then(res => {
          if (res.data.Data) {
            // this.form = res.data.Data.Detail
            this.treeList = res.data.Data.Items
          }
        })
      }
    },
  }
}
</script>

<style></style>